import { FacilitySummaryObject, FacilitySummaryStaffPermissionDataObject } from 'src/app/core/services/facility.model';
import { FeatureFlagsService } from 'src/app/core/shared-service/feature-flags.service';
import { allStaffPermissions, staffPermission,userPermissions,staffActions } from './../services/staff.model';

export function getStaffPermission(featureService: FeatureFlagsService, facilitySummary: FacilitySummaryObject, 
        isEdit:boolean, userRights:userPermissions, ownAccount: boolean) {
    const _editStaff = isEdit;
    const _haloTrainingLearnMoreURL = 'https://www.lifefitness.com/en-us/halo/training';
    const _lfodPremiumLearnMoreURL = 'https://halofitness.zendesk.com/hc/en-us/articles/4408263855117';
    const _digitalCoachLearnMoreURL = 'https://halofitness.zendesk.com/hc/en-us/articles/4409119137165';

    let facilityStaffPermission: staffPermission[] = [];
    facilityStaffPermission.push(
        new staffPermission(
            'facility',
            'FACILITY.HEADER.1',
            'FACILITY.MSG.1', false, '', '',
            facilitySummary.staffPermissionData.facilityEnabled === 'true' 
            && facilitySummary.facilityRights.facility === 'true' 
            ? 'true' : 'false',
            _editStaff ? userRights.facility : 'F',
            '', false,
            { F: 'true', V: 'true', H: 'false' },
            ownAccount
        )
    );
    facilityStaffPermission.push(
        new staffPermission(
            'facilityStaff',
            'FACILITY.HEADER.2',
            'FACILITY.MSG.2',false, '', '',
            facilitySummary.staffPermissionData.facilityStaffEnabled === 'true' 
            && facilitySummary.facilityRights.facility === 'true' 
            ? 'true' : 'false',
            _editStaff ? userRights.facilityStaff : 'F',
            '', false,
            { F: 'true', V: 'true', H: 'true' },
            ownAccount
        )
    );
    facilityStaffPermission.push(
        new staffPermission(
            'branding',
            'BRANDING',
            'FACILITY.MSG.3', true, 'AVAILABLE.PLAN.MSG',
            _haloTrainingLearnMoreURL,
            facilitySummary.staffPermissionData.brandingEnabled === 'true' 
            && facilitySummary.facilityRights.facility === 'true' 
            ? 'true' : 'false',
            _editStaff ? userRights.branding : 'F',
            '', false,
            { F: 'true', V: 'false', H: 'true' },
            ownAccount
        )
    );

    let equipmentManagementPermission: staffPermission[] = [];
    equipmentManagementPermission.push(
        new staffPermission(
            'customize',
            'MENU.EQUIPSETTING',
            'EQUIP.MSG.1', false, '', '',
            facilitySummary.staffPermissionData.customizeEnabled === 'true' 
            && facilitySummary.facilityRights.customize === 'true' 
            ? 'true' : 'false',
            _editStaff ? userRights.customize : 'F',
            '', false,
            { F: 'true', V: 'true', H: 'true' },
            ownAccount
        )
    );
    equipmentManagementPermission.push(
        new staffPermission(
            'software',
            'SOFTWARE',
            'EQUIP.MSG.2', false, '', '',
            facilitySummary.staffPermissionData.softwareEnabled === 'true' 
            && facilitySummary.facilityRights.software === 'true' 
            ? 'true' : 'false',
            _editStaff ? userRights.software : 'F',
            '', false,
            { F: 'true', V: 'true', H: 'true' },
            ownAccount
        )
    );
    equipmentManagementPermission.push(
        new staffPermission(
            'stats',
            'MENU.STATS',
            'EQUIP.MSG.3', false, '', '',
            facilitySummary.staffPermissionData.statsEnabled === 'true' 
            && facilitySummary.facilityRights.stats === 'true' 
            ? 'true' : 'false',
            _editStaff ? userRights.stats : 'F',
            '', false,
            { F: 'true', V: 'true', H: 'true' },
            ownAccount
        )
    );
    equipmentManagementPermission.push(
        new staffPermission(
            'lfodEnabledEquipment',
            'CONTENT.MANAGER.ENABLE.EQUIPMENT',
            'CONTENT.MANAGER.ENABLE.EQUIPMENT.MSG', false, '',
            _lfodPremiumLearnMoreURL,
            facilitySummary.facilityRights.lfodEnabledEquipment,
            _editStaff ? userRights.lfodEnabledEquipment : 'F',
            '', true,
            { F: 'true', V: 'true', H: 'true' },
            ownAccount
        )
    );

    if(featureService.isOn('poseidon-milestone-3')) {
        equipmentManagementPermission.push(
            new staffPermission(
                'customLibrary',
                'CONTENT.MANAGER.CUSTOM.LIBRARY',
                'CONTENT.MANAGER.CUSTOM.LIBRARY.MSG', false, '',
                '',
                facilitySummary.facilityRights.customLibrary,
                _editStaff ? userRights.customLibrary : 'F',
                '', true,
                { F: 'true', V: 'true', H: 'true' },
                ownAccount
            )
        );
    }

    equipmentManagementPermission.push(
        new staffPermission(
            'digitalCoach',
            'SUBSCRIPTION.DIGITAL.COACH',
            'EQUIP.MSG.5', true, '',
            _digitalCoachLearnMoreURL,
            facilitySummary.facilityRights.digitalCoach,
            _editStaff ? userRights.digitalCoach : 'F',
            '', true,
            { F: 'true', V: 'false', H: 'true' },
            ownAccount
        )
    );
    
    

    let serviceMaintenancePermission: staffPermission[] = [];
    serviceMaintenancePermission.push(
        new staffPermission(
            'serviceNotice',
            'SERVICE.HEADER.1',
            'SERVICE.MSG.1', false, '', '',
            facilitySummary.staffPermissionData.serviceNoticeEnabled === 'true' 
            && facilitySummary.facilityRights.serviceNotice === 'true' 
            ? 'true' : 'false',
            _editStaff ? userRights.serviceNotice : 'F',
            'false', false,
            { F: 'true', V: 'true', H: 'true' },
            ownAccount
        )
    );
    serviceMaintenancePermission.push(
        new staffPermission(
            'serviceNotice',
            'JOBTRACKER',
            'SERVICE.JOBTRACKER.MSG', false, '', '',
            (
                facilitySummary.staffPermissionData.jobTrackerEnabled && !facilitySummary.staffPermissionData.serviceNoticeEnabled
            ).toString(),
            _editStaff ? userRights.serviceNotice : 'F',
            'false', false,
            { F: 'true', V: 'true', H: 'true' },
            ownAccount
        )
    );
    serviceMaintenancePermission.push(
        new staffPermission(
            'calendar',
            'SERVICE.HEADER.2',
            'SERVICE.MSG.2', false, '', '',
            facilitySummary.staffPermissionData.calendarEnabled === 'true' 
            && facilitySummary.facilityRights.serviceNotice === 'true' 
            ? 'true' : 'false',
            _editStaff ? userRights.calendar : 'F',
            'false', false,
            { F: 'true', V: 'false', H: 'true' },
            ownAccount
        )
    );
    serviceMaintenancePermission.push(
        new staffPermission(
            'disconnectNotification',
            'SERVICE.NOT.CONNECTED.EMAIL.HEADER',
            'SERVICE.NOT.CONNECTED.EMAIL.MESSAGE', false, '', '',
            facilitySummary.facilityRights.serviceNotice === 'true' 
            ? 'true' : 'false',
            _editStaff ? userRights.disconnectNotification : 'false',
            'true', false,
            { F: '', V: '', H: '' },
            ownAccount
        )
    );

    let membershipsPromotionsPermission: staffPermission[] = [];
    membershipsPromotionsPermission.push(
        new staffPermission(
            'membersManage',
            'MEMBERSHIP.HEADER.1',
            'MEMBERSHIP.MSG.1', true, 'AVAILABLE.PLAN.MSG',
            _haloTrainingLearnMoreURL,
            facilitySummary.staffPermissionData.membersManageEnabled === 'true' 
            && facilitySummary.facilityRights.membersMenu === 'true' 
            ? 'true' : 'false',
            _editStaff ? userRights.membersManage : 'F',
            '', false,
            { F: 'true', V: 'false', H: 'true' },
            ownAccount
        )
    );
    membershipsPromotionsPermission.push(
        new staffPermission(
            'membersRetention',
            'RETAIN.MENU',
            'MEMBERSHIP.MSG.2', true, 'AVAILABLE.PLAN.MSG',
            _haloTrainingLearnMoreURL,
            facilitySummary.staffPermissionData.membersRetentionEnabled === 'true' 
            && facilitySummary.facilityRights.membersMenu === 'true' 
            ? 'true' : 'false',
            _editStaff ? userRights.membersRetention : 'F',
            '', false,
            { F: 'true', V: 'false', H: 'true' },
            ownAccount
        )
    );
    membershipsPromotionsPermission.push(
        new staffPermission(
            'membersPromote',
            'PROMOTE',
            'MEMBERSHIP.MSG.3', true, 'AVAILABLE.PLAN.MSG',
            _haloTrainingLearnMoreURL,
            facilitySummary.staffPermissionData.membersPromoteEnabled === 'true' 
            && facilitySummary.facilityRights.membersMenu === 'true' 
            ? 'true' : 'false',
            _editStaff ? userRights.membersPromote : 'F',
            '', false,
            { F: 'true', V: 'false', H: 'true' },
            ownAccount
        )
    );
    membershipsPromotionsPermission.push(
        new staffPermission(
            'membersChallenges',
            'CHALLENGES',
            'MEMBERSHIP.MSG.4', true, 'AVAILABLE.PLAN.MSG',
            _haloTrainingLearnMoreURL,
            facilitySummary.staffPermissionData.membersChallengesEnabled === 'true' 
            && facilitySummary.facilityRights.membersMenu === 'true' 
            ? 'true' : 'false',
            _editStaff ? userRights.membersChallenges : 'F',
            '', false,
            { F: 'true', V: 'false', H: 'true' },
            ownAccount
        )
    );
    let trainingClassesPermission: staffPermission[] = [];
    trainingClassesPermission.push(
        new staffPermission(
            'trainingPrograms',
            'PROGRAMS',
            'TRAINING.MSG.1', true, 'AVAILABLE.PLAN.MSG',
            _haloTrainingLearnMoreURL,
            facilitySummary.staffPermissionData.trainingProgramsEnabled === 'true' 
            && facilitySummary.facilityRights.trainingMenu === 'true' 
            ? 'true' : 'false',
            _editStaff ? userRights.trainingPrograms : 'F',
            '', false,
            { F: 'true', V: 'false', H: 'true' },
            ownAccount
        )
    );
    trainingClassesPermission.push(
        new staffPermission(
            'trainingClasses',
            'CLASSES',
            'TRAINING.MSG.2', true, 'AVAILABLE.PLAN.MSG',
            _haloTrainingLearnMoreURL,
            facilitySummary.staffPermissionData.trainingClassesEnabled === 'true' 
            && facilitySummary.facilityRights.trainingMenu === 'true' 
            ? 'true' : 'false',
            _editStaff ? userRights.trainingClasses : 'F',
            '', false,
            { F: 'true', V: 'false', H: 'true' },
            ownAccount
        )
    );

    let allStaffPermission: allStaffPermissions[] = [];

    allStaffPermission.push(
        new allStaffPermissions(
            'FACILITY.ACCESS.HEADER', 
            facilitySummary.staffPermissionData.facilityEnabled === 'true' 
            && facilitySummary.facilityRights.facility === 'true' 
            ? 'true' : 'false', 
            '', 
            facilityStaffPermission
        )
    );

    allStaffPermission.push(
        new allStaffPermissions(
            'EQUIPMENT.MNGMNT.HEADER',
            facilitySummary.staffPermissionData.equipmentSettingsEnabled === 'true' 
            && facilitySummary.facilityRights.customize === 'true' 
            ? 'true' : 'false',
            '',
            equipmentManagementPermission
        )
    );

    allStaffPermission.push(
        new allStaffPermissions(
            'SERVICE.MAINTENANCE.HEADER',
            facilitySummary.staffPermissionData.serviceNoticeEnabled === 'true' 
            && facilitySummary.facilityRights.serviceNotice === 'true' 
            ? 'true' : 'false',
            'alwaysTrue',
            serviceMaintenancePermission
        )
    );
    allStaffPermission.push(
        new allStaffPermissions(
            'MEMBERSHIPS.PROMOTIONS.HEADER',
            facilitySummary.staffPermissionData.membersEnabled === 'true' 
            && facilitySummary.facilityRights.membersMenu === 'true' 
            ? 'true' : 'false',
            '',
            membershipsPromotionsPermission
        )
    );

    allStaffPermission.push(
        new allStaffPermissions(
            'TRAINING.PROGRAMS.HEADER',
            facilitySummary.staffPermissionData.trainingEnabled === 'true' 
            && facilitySummary.facilityRights.trainingMenu === 'true' 
            ? 'true' : 'false',
            '',
            trainingClassesPermission
        )
    );

    return allStaffPermission;
}
